(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 57982:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'magnifying-glass';
var width = 512;
var height = 512;
var aliases = [128269,"search"];
var unicode = 'f002';
var svgPathData = 'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMagnifyingGlass = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 95337:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(57982);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.wn = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(39176);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/common/basicContent.tsx + 20 modules
var basicContent = __webpack_require__(68656);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/models/Models.bs.js
var Models_bs = __webpack_require__(37698);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/LayoutDataContext.bs.js
var LayoutDataContext_bs = __webpack_require__(37110);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchBar.bs.js + 3 modules
var SearchBar_bs = __webpack_require__(38238);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchBar__ListItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



var listItem = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* cursor */.ocY("pointer"),
    BsCssJs_bs/* paddingTop */.odA(BsCssJs_bs/* rem */.hOB(1.0)),
    BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs/* rem */.hOB(1.0)),
    BsCssJs_bs/* borderBottom */.h$9(BsCssJs_bs.px(1), "solid", Theme_Color_bs/* Personal.paleGrey */.RL.paleGrey),
    BsCssJs_bs/* selector */.nZE("a", [
        BsCssJs_bs/* display */.jfB("block"),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100.0)),
        BsCssJs_bs/* textDecoration */.QXS("none"),
        BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.darkGrey */.RL.darkGrey)
    ]),
    BsCssJs_bs/* selector */.nZE("&:last-of-type", [
        BsCssJs_bs/* borderBottomWidth */.HMX(BsCssJs_bs.px(0))
    ])
]);
var Styles = {
    listItem: listItem
};
function SearchBar__ListItem(props) {
    return jsx_runtime.jsx("li", {
        children: props.children,
        className: listItem
    });
}
var make = SearchBar__ListItem;
 /* listItem Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/string.js + 4 modules
var string = __webpack_require__(99813);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_string.js
var js_string = __webpack_require__(37712);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchContext.bs.js
var SearchContext_bs = __webpack_require__(12776);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchBar__ListItemText.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var highlight = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* fontWeight */.Ue2({
        NAME: "num",
        VAL: 700
    })
]);
var SearchBar_ListItemText_bs_Styles = {
    highlight: highlight
};
function annotateByString(input, searchTerm) {
    var sanitisedTerm = string/* trim */.fy(js_string/* replaceByRe */.jt(/([^\w\s\d])/g, "\\$1", searchTerm));
    var re = new RegExp("(" + sanitisedTerm + ")", "gim");
    return belt_Array/* keepMapU */.bP(js_string/* splitByRe */.M4(re, input), function(v) {
        if (v !== undefined && v !== "") {
            return re.test(v) ? {
                NAME: "mark",
                VAL: v
            } : {
                NAME: "text",
                VAL: v
            };
        }
    });
}
function SearchBar__ListItemText(props) {
    var search = react.useContext(SearchContext_bs/* context */.D);
    var annotatedStr = annotateByString(props.text, search);
    return belt_Array/* mapWithIndex */.Su(annotatedStr, function(idx, s) {
        if (s.NAME === "text") {
            return jsx_runtime.jsx(react.Fragment, {
                children: s.VAL
            }, "txt-" + String(idx) + "");
        } else {
            return jsx_runtime.jsx("span", {
                children: s.VAL,
                className: highlight
            }, "txt-" + String(idx) + "");
        }
    });
}
var SearchBar_ListItemText_bs_make = SearchBar__ListItemText;
 /* highlight Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/index/SearchBarSection.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
















var container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(12)),
    tl: {
        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs.px(12)),
        tl: {
            hd: BsCss_bs/* important */.efO(BsCss_bs/* zIndex */.W5D(20)),
            tl: /* [] */ 0
        }
    }
});
var SearchBarSection_bs_Styles = {
    container: container
};
function containsSearchTerm(text, searchTerm) {
    return text.toLowerCase().includes(searchTerm.toLowerCase());
}
function filterList(skus, searchStr) {
    return belt_Array/* slice */.tP(belt_Array/* keepMap */.fe(skus, function(item) {
        if (containsSearchTerm(item.name, searchStr)) {
            return item;
        }
    }), 0, 5);
}
function mapToListItem(sku) {
    var card = Models_bs/* Card.skuToCard */.Zb.skuToCard(sku);
    return {
        name: card.name,
        id: card.uid,
        slug: card.slug
    };
}
var SearchBarHelpers = {
    containsSearchTerm: containsSearchTerm,
    filterList: filterList,
    mapToListItem: mapToListItem
};
function SearchBarSection(props) {
    var inventory = props.inventory;
    var router = next_router.useRouter();
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var placeholder = react.useMemo(function() {
        var defaultPlaceholder = "Search retailers...";
        if (state !== undefined && state.searchBarPlaceholder.length > 0) {
            return state.searchBarPlaceholder;
        } else {
            return defaultPlaceholder;
        }
    }, [
        belt_Option/* map */.UI(state, function(c) {
            return c.searchBarPlaceholder;
        })
    ]);
    var skus = react.useRef([]);
    var match = react.useState(function() {
        return "";
    });
    var setSearch = match[1];
    var search = match[0];
    var match$1 = react.useState(function() {
        return [];
    });
    var setList = match$1[1];
    var list = match$1[0];
    react.useEffect(function() {
        skus.current = belt_Option/* mapWithDefault */.k7(inventory, [], function(i) {
            return i.skus;
        });
    }, [
        inventory
    ]);
    var onEnter = react.useCallback(function(str) {
        router.push("/store/?search=" + encodeURIComponent(str));
    }, [
        router,
        list
    ]);
    var onChange = react.useCallback(function(searchStr) {
        curry._1(setSearch, function(param) {
            return searchStr.trim();
        });
        if (searchStr.trim() === "") {
            return curry._1(setList, function(param) {
                return [];
            });
        }
        var filteredCards = filterList(skus.current, searchStr);
        curry._1(setList, function(param) {
            return filteredCards;
        });
    }, []);
    var onReset = react.useCallback(function(param) {
        curry._1(setSearch, function(param) {
            return "";
        });
        curry._1(setList, function(param) {
            return [];
        });
        Segment_bs/* customElementInteraction */.pA({
            element: "clear_search",
            journey: "classic_product_search"
        });
    }, []);
    var listItems = belt_Array/* map */.UI(list, function(sku) {
        var item = mapToListItem(sku);
        var products = belt_Array/* keep */.Cn(skus.current, function(sku) {
            return sku.name === item.name;
        });
        return jsx_runtime.jsx(make, {
            children: jsx_runtime.jsx((link_default()), {
                href: "/store/" + item.slug,
                prefetch: false,
                children: jsx_runtime.jsx("a", {
                    children: jsx_runtime.jsx(SearchBar_ListItemText_bs_make, {
                        text: item.name
                    }),
                    onClick: function onClick(param) {
                        Segment_bs/* productsSearched */.l$({
                            query: search,
                            search_count: 1,
                            products: belt_Array/* mapWithIndex */.Su(products, Segment_bs/* cardToProductWithIndex */.bC),
                            search_location: "home",
                            suggested_search: item.name
                        });
                    }
                })
            })
        }, item.id);
    });
    return jsx_runtime.jsx("section", {
        children: jsx_runtime.jsx(SearchBar_bs/* make */.Sy, {
            onChange: onChange,
            onEnter: onEnter,
            onReset: onReset,
            className: container,
            placeholder: placeholder,
            children: listItems
        }),
        className: Cn_bs/* make */.S([
            IndexStyles_bs/* fullWidthSection */.wt,
            "search-bar"
        ])
    });
}
var Link$1;
var SearchBarSection_bs_make = SearchBarSection;
 /* container Not a pure module */ 

// EXTERNAL MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Decoder__List.bs.js
var Gql_SkuPresentation_Decoder_List_bs = __webpack_require__(1651);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/contexts/LayoutDataContext.ts
var LayoutDataContext = __webpack_require__(25149);
;// CONCATENATED MODULE: ./src/components/pages/index/LogoSchemaMarkup.tsx



var LogoSchemaMarkup = function() {
    var ref, ref1;
    var layoutData = (0,LayoutDataContext/* useLayoutData */.Q)();
    var logoMarkup = {
        "@context": "https://schema.org/",
        "@type": "Organization",
        logo: layoutData === null || layoutData === void 0 ? void 0 : (ref = layoutData.headerLogo) === null || ref === void 0 ? void 0 : (ref1 = ref.classicLogo) === null || ref1 === void 0 ? void 0 : ref1.url,
        url: "https://www.prezzee.com/"
    };
    var jsonLd = JSON.stringify(logoMarkup);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
        async: true,
        id: "logo-schema",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: jsonLd
        }
    });
};
/* harmony default export */ var index_LogoSchemaMarkup = (LogoSchemaMarkup);

;// CONCATENATED MODULE: ./src/pages/index.tsx




__webpack_require__(14473);





var Page = function(param) {
    var layerEnabled = param.layerEnabled, content = param.content, inventory = param.inventory, skuList = param.skuList;
    var skuDict = (0,Gql_SkuPresentation_Decoder_List_bs/* parse */.Qc)(skuList).map(function(sku) {
        return sku.codename;
    });
    var extraProps = (0,_define_property/* default */.Z)({}, basicContent/* ContentBlockName.SkuCarouselBlock */.Q2.SkuCarouselBlock, {
        props: {
            inventory: inventory,
            skuDict: skuDict
        }
    });
    var inventoryWithoutHiddenCards = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inventory), {
        skus: inventory.skus.filter(function(sku) {
            return !sku.hideFromAllClassicCategories;
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            (0,basicContent/* parseSeoMetadata */.Og)(content),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_LogoSchemaMarkup, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SearchBarSection_bs_make, {
                inventory: inventoryWithoutHiddenCards
            }),
            (0,basicContent/* parseBasicPageContent */.S7)(content, basicContent/* ContentLayout.Classic */.Dv.Classic, extraProps, {
                layerEnabled: layerEnabled
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Page);


/***/ }),

/***/ 45719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE



function clickAwayCatcher(idx) {
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("fixed"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .wey(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$v(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bottom */ .IaC(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2z(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor */ .Czw("transparent"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zIndex */ .W5D(idx)
    ]);
}
var Styles = {
    clickAwayCatcher: clickAwayCatcher
};
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(function(props) {
    var zIndex = props.zIndex;
    var zIndex$1 = zIndex !== undefined ? zIndex : -1;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        "aria-hidden": true,
        className: clickAwayCatcher(zIndex$1),
        onClick: props.onClick
    });
});
 /* make Not a pure module */ 


/***/ }),

/***/ 38238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sy": function() { return /* binding */ SearchBar_bs_make; }
});

// UNUSED EXPORTS: Icon, Input, ListItem, ListItemText, Styles, SuggestionList

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Js_Core.bs.js
var Css_Js_Core_bs = __webpack_require__(32885);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchContext.bs.js
var SearchContext_bs = __webpack_require__(12776);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchBar__Icon.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var icon = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.primaryRed */.RL.primaryRed),
    BsCssJs_bs/* position */.FKU("absolute"),
    BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs.px(9999)),
    BsCssJs_bs/* width */.bf$(BsCssJs_bs/* rem */.hOB(2.25)),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* rem */.hOB(2.25)),
    BsCssJs_bs/* top */.wey(BsCssJs_bs/* rem */.hOB(0.375)),
    BsCssJs_bs/* left */.t$v(BsCssJs_bs/* rem */.hOB(0.375)),
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.white */.RL.white),
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* justifyContent */.KlP("center"),
    BsCssJs_bs/* alignItems */.cq$("center")
]);
var Styles = {
    icon: icon
};
var make = /*#__PURE__*/ react.memo(function(props) {
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: icon
    });
});
 /* icon Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/ClickAwayCatcher/ClickAwayCatcher.bs.js
var ClickAwayCatcher_bs = __webpack_require__(45719);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchBar__Input.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






var input = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.darkGrey */.RL.darkGrey),
    BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs/* rem */.hOB(3.75)),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* rem */.hOB(3.0)),
    BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs/* rem */.hOB(3)),
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs/* rem */.hOB(1.0)),
    BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs/* rem */.hOB(1.5)),
    BsCssJs_bs/* border */.CgR(BsCssJs_bs.px(0), "solid", "transparent"),
    BsCssJs_bs/* outline */.Kl7(BsCssJs_bs.px(0), "solid", "transparent")
]);
var inputOpened = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* borderBottomLeftRadius */.AGO(BsCssJs_bs.px(0)),
    BsCssJs_bs/* borderBottomRightRadius */.rfy(BsCssJs_bs.px(0)),
    BsCssJs_bs/* borderBottomWidth */.HMX(BsCssJs_bs.px(0))
]);
var SearchBar_Input_bs_Styles = {
    input: input,
    inputOpened: inputOpened
};
var SearchBar_Input_bs_make = /*#__PURE__*/ react.memo(function(props) {
    var value = props.value;
    var onEnter = props.onEnter;
    var onKeyDown = react.useCallback(function(e) {
        var key = e.key;
        var keyCode = e.keyCode;
        if (key === "Enter" || keyCode === 13) {
            return curry._1(onEnter, value);
        }
    }, [
        onEnter,
        value
    ]);
    return jsx_runtime.jsx("input", {
        className: classnames_default()([
            input,
            props.listOpened ? inputOpened : ""
        ]),
        placeholder: props.placeholder,
        value: value,
        onKeyDown: onKeyDown,
        onFocus: props.onFocus,
        onChange: props.onChange
    });
});
 /* input Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Fonts.bs.js
var Theme_Fonts_bs = __webpack_require__(1476);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchBar__SuggestionList.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var listWrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.white */.RL.white),
    BsCssJs_bs/* borderBottomRightRadius */.rfy(BsCssJs_bs/* rem */.hOB(1.5)),
    BsCssJs_bs/* borderBottomLeftRadius */.AGO(BsCssJs_bs/* rem */.hOB(1.5)),
    BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100.0)),
    BsCssJs_bs/* selector */.nZE("ul", [
        BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.darkGrey */.RL.darkGrey),
        BsCssJs_bs/* listStyleType */.jZR("none"),
        BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(0)),
        BsCssJs_bs/* marginBottom */.yl7(BsCssJs_bs/* rem */.hOB(0.375)),
        BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs/* rem */.hOB(1.25)),
        BsCssJs_bs/* unsafe */.K47("marginBlockStart", "0px"),
        BsCssJs_bs/* unsafe */.K47("marginBlockEnd", "0.375rem"),
        Theme_Fonts_bs/* SofiaPro.family */.t.family,
        BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs/* rem */.hOB(1.25))
    ])
]);
var SearchBar_SuggestionList_bs_Styles = {
    listWrapper: listWrapper
};
function SearchBar__SuggestionList(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx("ul", {
            children: props.children
        }),
        className: listWrapper
    });
}
var SearchBar_SuggestionList_bs_make = SearchBar__SuggestionList;
 /* listWrapper Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faTimes.js
var faTimes = __webpack_require__(59545);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faSearch.js
var faSearch = __webpack_require__(95337);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SearchBar/SearchBar.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE















var base = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* position */.FKU("relative"),
    BsCssJs_bs/* minHeight */.jw4(BsCssJs_bs/* rem */.hOB(3.0)),
    BsCssJs_bs/* zIndex */.W5D(5000)
]);
var wrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* position */.FKU("absolute"),
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100.0)),
    BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs/* rem */.hOB(1.5)),
    BsCssJs_bs/* flexDirection */.Me8("column"),
    BsCssJs_bs/* boxShadow */.Wnp(Css_Js_Core_bs/* Shadow.box */.jXB.box(BsCssJs_bs.px(4), BsCssJs_bs.px(4), BsCssJs_bs.px(25), undefined, undefined, BsCssJs_bs/* rgba */.m4f(0, 0, 0, BsCssJs_bs/* pct */.hdZ(20.0))))
]);
var resetButton = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* position */.FKU("absolute"),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* rem */.hOB(3)),
    BsCssJs_bs/* width */.bf$(BsCssJs_bs/* rem */.hOB(3)),
    BsCssJs_bs/* top */.wey("zero"),
    BsCssJs_bs/* right */.F2z("zero"),
    BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs/* rem */.hOB(0.75)),
    BsCssJs_bs/* boxSizing */.ixg("borderBox"),
    BsCssJs_bs/* selector */.nZE("button", [
        BsCssJs_bs/* unsafe */.K47("border", "none"),
        BsCssJs_bs/* backgroundColor */.Czw("transparent"),
        BsCssJs_bs/* padding */.o3D("zero"),
        BsCssJs_bs/* outline */.Kl7(BsCssJs_bs.px(0), "solid", "transparent"),
        BsCssJs_bs/* cursor */.ocY("pointer"),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* pct */.hdZ(100))
    ])
]);
var clearIcon = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(BsCssJs_bs/* hex */.$v1("395fa0")),
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(14)),
    BsCssJs_bs/* boxSizing */.ixg("contentBox"),
    BsCssJs_bs/* paddingTop */.odA(BsCssJs_bs.px(7))
]);
var SearchBar_bs_Styles = {
    base: base,
    wrapper: wrapper,
    resetButton: resetButton,
    clearIcon: clearIcon
};
function SearchBar(props) {
    var children = props.children;
    var className = props.className;
    var onReset = props.onReset;
    var onChange = props.onChange;
    var className$1 = className !== undefined ? className : "";
    var match = react.useState(function() {
        return false;
    });
    var setFocused = match[1];
    var listOpened = match[0] && react.Children.count(children) > 0;
    var match$1 = react.useState(function() {
        return "";
    });
    var setValue = match$1[1];
    var value = match$1[0];
    var onReset$1 = react.useCallback(function(param) {
        curry._1(setValue, function(param) {
            return "";
        });
        curry._1(onReset, undefined);
    }, [
        onChange,
        setValue
    ]);
    var onChange$1 = react.useCallback(function(e) {
        var val = e.target.value;
        curry._1(setValue, function(param) {
            return val;
        });
        curry._1(onChange, val);
    }, [
        onChange,
        setValue
    ]);
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx(make, {
                    children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                        icon: faSearch/* faSearch */.wn
                    })
                }),
                jsx_runtime.jsx(SearchBar_Input_bs_make, {
                    onChange: onChange$1,
                    onEnter: props.onEnter,
                    listOpened: listOpened,
                    value: value,
                    placeholder: props.placeholder,
                    onFocus: function onFocus(param) {
                        curry._1(setFocused, function(param) {
                            return true;
                        });
                    }
                }),
                value.length > 0 ? jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx("button", {
                        children: belt_Option/* getWithDefault */.tj(props.resetIcon, jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: faTimes/* faTimes */.NB,
                            className: clearIcon
                        })),
                        onClick: onReset$1
                    }),
                    className: resetButton
                }) : null,
                jsx_runtime.jsx(SearchContext_bs/* Provider.make */.z.make, {
                    value: value,
                    children: listOpened ? jsx_runtime.jsxs(jsx_runtime.Fragment, {
                        children: [
                            jsx_runtime.jsx(SearchBar_SuggestionList_bs_make, {
                                children: children
                            }),
                            jsx_runtime.jsx(ClickAwayCatcher_bs/* make */.S, {
                                onClick: function onClick(param) {
                                    curry._1(setFocused, function(param) {
                                        return false;
                                    });
                                }
                            })
                        ]
                    }) : null
                })
            ],
            className: wrapper
        }),
        className: classnames_default()([
            base,
            className$1
        ])
    });
}
var Input;
var SuggestionList;
var ListItem;
var ListItemText;
var Icon;
var SearchBar_bs_make = SearchBar;
 /* base Not a pure module */ 


/***/ }),

/***/ 12776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ context; },
/* harmony export */   "z": function() { return /* binding */ Provider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// Generated by ReScript, PLEASE EDIT WITH CARE

var context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext("");
var provider = context.Provider;
function SearchContext$Provider(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(provider, {
        value: props.value,
        children: props.children
    });
}
var Provider = {
    provider: provider,
    make: SearchContext$Provider
};
 /* context Not a pure module */ 


/***/ }),

/***/ 79894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://files.prezzee.com/apps/consumer-woc/client/consumer-woc.remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["consumer_woc"]) {
      return resolve(window.remoteLoading["consumer_woc"])
    }

    var res, rej;
    window.remoteLoading["consumer_woc"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["consumer_woc"] !== 'undefined') {
      res(window["consumer_woc"]);
      return resolve(window["consumer_woc"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["consumer_woc"] !== 'undefined') {
          res(window["consumer_woc"]);
          return resolve(window["consumer_woc"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "consumer_woc"
    );
  }).then(function () {
    const proxy = {
      get: consumer_woc.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          consumer_woc.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        consumer_woc.__initialized = true
      }
    }
    if (!consumer_woc.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3995,8929,8764,6562,8687,9304,653,4426,8733,7396,7035,5881,4135,1727,4540,203,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);